/**
 * isDateBetween
 * @param date
 * @param start
 * @param end
 */
export const isDateBetween = (date: Date, start: Date, end: Date): boolean =>
  date > start && date < end;

export const isDatePassed = (date: Date, expiry = new Date()): boolean =>
  date < expiry;
